import * as React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { EditorState } from 'draft-js';
import ReactTooltip from 'react-tooltip';

import { QTYPES, QuestionSummary, SPECIAL_QIDS } from '@nexxt/common/types';
import { IApplicationState } from '../../../../../reducers';
import { Project } from '@nexxt/common/types';
import * as Actions from '../../../../../actions/project.actions';
import NotifyHOC from '../../../../../HOC/Notifications';
import { Dispatch } from 'redux';
import RichTextTranslation from '../../../../common/richTextField/Readonly';
import Icons from '../../../../common/designElements/Icons';
import { QuestionTypesMap } from '@nexxt/common/questionTypes';
import HealthIcon from '../../../../common/designElements/HealthIcon';

export interface IGreetingCardProps {
    project: Project;
    search: string;
    currentQuestion: any;
    health?: any;
    disabled: boolean;
    actions: {
        edit: (question: Partial<QuestionSummary>) => void;
        preview: (questoin: any) => void;
    };
    onSelectQuestion: (question: Partial<QuestionSummary>) => void;
}

const GreetingCard: React.SFC<IGreetingCardProps> = (props) => {
    const { disabled } = props;
    let greetingText = props.project.greetingText;
    if (
        props.search &&
        (props.project.greetingLabel || 'Greeting Text')
            .toLowerCase()
            .indexOf(props.search.toLowerCase()) === -1
    ) {
        return null;
    }
    if (typeof greetingText === 'string') {
        greetingText = null;
    }
    if (Array.isArray(greetingText)) {
        const firstValidLanguageIndex = greetingText?.findIndex(
            (greeting) => greeting?.language == props.project.languages[0].value
        );
        greetingText =
            greetingText?.[firstValidLanguageIndex]?.contents?.[0]?.richText;
    }
    const questionTypeItem = QuestionTypesMap[QTYPES.GREETING_TEXT];
    return (
        <div
            className={classnames(`question-card`, {
                active:
                    props.currentQuestion &&
                    props.currentQuestion.type === QTYPES.GREETING_TEXT,
                disabled
            })}
            onClick={() => {
                props.onSelectQuestion({ type: QTYPES.GREETING_TEXT });
            }}
        >
            <div className="q-card-pre-header">
                <span
                    className="pre-header-icon"
                    data-tip="custom show"
                    data-for={`greeting`}
                >
                    <Icons type="greeting" width={25} />
                </span>
                <ReactTooltip
                    className="pre-header-tooltip"
                    id={`greeting`}
                    aria-haspopup="true"
                    effect="solid"
                    place="right"
                    arrowColor={'transparent'}
                >
                    <span>GREETING MESSAGE</span>
                </ReactTooltip>
                {/* <span className="pre-header-label">GREETING MESSAGE</span> */}
            </div>
            <div className="q-card-header">
                <span className="question-image">
                    <img src={questionTypeItem.image} />
                </span>
                <span className="question-label">
                    {props.project.greetingLabel || 'Greeting Text'}
                </span>
                <HealthIcon
                    questionID={SPECIAL_QIDS.GREETING_TEXT}
                    active={!!props.health}
                    type={props.health?.type}
                    className={`health ${props.health?.type?.toLowerCase()}`}
                    message={props.health && props.health.list[0].message}
                />
            </div>
            <div className="q-card-body">
                <div className="card-content">
                    {props.project.greetingText && (
                        <RichTextTranslation value={greetingText} />
                    )}
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (store: IApplicationState) => {
    const {
        questionReducer: { currentQuestion },
        projectReducer: { currentProject }
    } = store;
    return {
        currentQuestion,
        project: currentProject
    };
};

const mapDispatchToProps = (dispatch: Dispatch<any>) => ({});

export default NotifyHOC(
    connect(mapStateToProps, mapDispatchToProps)(GreetingCard)
);
